import {OfferDoc as BaseOfferDoc} from '@mapit/opensearch-client/dist/types'
import {
  Actor,
  Client,
  LogItem,
  Offer,
  OfferType,
  Pack,
  Packs,
  Product,
  RejectionReason,
  Status,
} from '@muvio/honda-offers-builder/model'

export interface OfferDoc extends BaseOfferDoc {
  lastActivityAt?: string
  reconfirmedAt?: string
  acceptedAt?: string
  rejectionReason?: RejectionReason
  rejectionReasonCustom?: string
  rejectedBy?: Actor
  commentLog?: LogItem[]
  emailSentAt?: string
  updatedAt?: string
}

export {Actor, Client, LogItem, Offer, OfferType, Pack, Packs, Product, RejectionReason, Status}

// TODO: update new types in @/types/offers
export const OfferTypePortal = {
  customer: OfferType.customer,
  subagent: OfferType.subagent,
  demobike: 'DEMO_BIKE',
  fleet: 'FLEET',
}

export const offerTypes = [
  OfferTypePortal.customer,
  OfferTypePortal.subagent,
  OfferTypePortal.demobike,
  OfferTypePortal.fleet,
]

export interface Pagination {
  page?: number
  itemsPerPage?: number
}
